// documentation for creating this component: https://floating-ui.com/docs/react
import {
    FloatingPortal, Placement, FloatingArrow, autoUpdate, flip, arrow, offset, shift, useDismiss,
    useFloating, useFocus, useHover, useInteractions, useRole
} from '@floating-ui/react';
import React from 'react';
import { useEffect, useState, useRef } from 'react';
import parse from 'html-react-parser';
import './ToolTip.css';

export type TooltipProps = {
    contents: React.ReactNode | string;
    placement?: Placement;
    children: string | JSX.Element;
    className?: string;
    tooltipClassName?: string;
    disabled?: boolean;
}

export default function ToolTip(props: TooltipProps) {
    const [open, setOpen] = useState(false);
    const arrowRef = useRef(null);
    const { x, y, refs, strategy, context } = useFloating({
        open,
        onOpenChange(open) {
            if (!props.disabled) setOpen(open);
        },
        placement: props.placement ? props.placement : "top",
        middleware: [offset(9),
        flip({ fallbackAxisSideDirection: "start", crossAxis: false }),
        shift(),
        arrow({
            element: arrowRef,
        })],
        whileElementsMounted: autoUpdate
    });

    const { getReferenceProps, getFloatingProps } = useInteractions([
        useHover(context, { move: false }),
        useFocus(context),
        useRole(context, { role: 'tooltip' }),
        useDismiss(context),
    ]);

    useEffect(() => {
        if (props.disabled) setOpen(false);
    }, [props.disabled]);

    return (<>
        <span className={props.className} ref={refs.setReference} {...getReferenceProps()} onClick={() => {
            //
        }}>
            {props.contents}
        </span>
        <FloatingPortal>
            {open && !props.disabled && (
                <div
                    className={props.tooltipClassName ? props.tooltipClassName : "ToolTip"}
                    ref={refs.setFloating}
                    style={{
                        position: strategy,
                        top: y ?? 0,
                        left: x ?? 0,
                    }}
                    {...getFloatingProps()}
                >
                    {
                        typeof props.children === "string" ?
                            parse(props.children)
                            :
                            props.children
                    }
                    <FloatingArrow ref={arrowRef} context={context} />
                </div>
            )}

        </FloatingPortal>
    </>);
}
